import { FALLBACK_LOCALE } from '@h20-shared/utils/number-format-utils';

/** What a table hands to every column callback as ag-grid's `context` */
export type GridContext = {
    /** A language tag such as `en` or `fr`, used to write numbers and dates the reader's way. */
    readonly locale: string;
};

export function gridLocale(context: unknown): string {
    if (
        typeof context === 'object' &&
        context !== null &&
        'locale' in context &&
        typeof context.locale === 'string'
    ) {
        return context.locale;
    }
    return FALLBACK_LOCALE;
}
